$(function () {
	APP.init()
})
